import React from 'react';
import { FormControl } from '@mui/material';

import { PropertySelectField } from '@paragon/client-tools';
import { MemberLabelContent, MemberLabelOptions } from '@paragon/contract-library';
import { humanCase } from '@paragon/utilities';

const memberLabelContentOptions: MemberLabelContent[] = ['MemberName', 'AssemblyName', 'OverallLength', 'Hidden'];

interface Props {
  memberLabelOptions: MemberLabelOptions;
  onChange: (memberLabelOptions: MemberLabelOptions) => void;
}

export function MemberLabelOptionsSelection(props: Props) {
  return (
    <>
      <FormControl margin="normal">
        <PropertySelectField<MemberLabelContent>
          property="Web label"
          value={props.memberLabelOptions.webLabelContent}
          options={memberLabelContentOptions}
          getName={humanCase}
          submit={(value) => void props.onChange({ ...props.memberLabelOptions, webLabelContent: value })}
        />
      </FormControl>
      <FormControl margin="normal">
        <PropertySelectField<MemberLabelContent>
          property="Non-web label"
          value={props.memberLabelOptions.nonWebLabelContent}
          options={memberLabelContentOptions}
          getName={humanCase}
          submit={(value) => void props.onChange({ ...props.memberLabelOptions, nonWebLabelContent: value })}
        />
      </FormControl>
    </>
  );
}
